module.exports = __webpack_public_path__ + "5029a58a27c3daf48f5a3a6f55ee8aef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/northern_funds.png
// module id = 1829
// module chunks = 0